module.exports = __webpack_public_path__ + "static/media/patient-left.9b93f9d4.jpg";